import { Button, Checkbox, Group, Modal, NumberInput, Stack, Switch, Text } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import { useEffect, useState } from "react";

type CopyIssueModalProps = {
  opened: boolean;
  canIncludeTasks?: boolean;
  defaultIncludeTasks?: boolean;
  issueName: string;
  taskNamePlural: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: (args: { copyCount: number; includeTasks: boolean; includeUserFields: boolean }) => Promise<void>;
};

const CopyIssueModal = ({
  opened,
  canIncludeTasks = false,
  defaultIncludeTasks = false,
  issueName,
  taskNamePlural,
  isLoading,
  onClose,
  onConfirm,
}: CopyIssueModalProps) => {
  const [copyCount, setCopyCount] = useState(1);
  const [includeTasks, setIncludeTasks] = useState(defaultIncludeTasks);
  const [includeUserFields, setIncludeUserFields] = useState(false);

  useEffect(() => {
    if (opened) {
      setCopyCount(1);
      setIncludeTasks(defaultIncludeTasks);
      setIncludeUserFields(false);
    }
  }, [defaultIncludeTasks, opened]);

  const submit = async () => {
    await onConfirm({
      copyCount,
      includeTasks: canIncludeTasks && includeTasks,
      includeUserFields,
    });
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Lag kopi" size="sm" centered>
      <Stack gap="md">
        <Text size="sm">Lag kopi av {issueName}.</Text>
        <NumberInput
          label="Antall kopier"
          value={copyCount}
          min={1}
          max={10}
          step={1}
          allowDecimal={false}
          allowNegative={false}
          onChange={(value) => setCopyCount(typeof value === "number" ? Math.min(10, Math.max(1, value)) : 1)}
        />
        {canIncludeTasks && (
          <Checkbox
            checked={includeTasks}
            onChange={(event) => setIncludeTasks(event.currentTarget.checked)}
            label={`Ta med ${taskNamePlural}`}
          />
        )}
        <Switch
          checked={includeUserFields}
          onChange={(event) => setIncludeUserFields(event.currentTarget.checked)}
          label="Ta med eier, ansvarlig og medlemmer"
        />
        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose} disabled={isLoading}>
            Avbryt
          </Button>
          <Button leftSection={<IconCopy size={16} />} onClick={submit} loading={isLoading}>
            Lag kopi
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default CopyIssueModal;
